module.exports = __webpack_public_path__ + "pc/img/work_detail3.18b2cbe7.jpg";